// extracted by mini-css-extract-plugin
export default {"container":"tab-container_container__yIpzr"};